import script from "./ProductInput.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductInput.vue?vue&type=script&setup=true&lang=js"

import "./ProductInput.vue?vue&type=style&index=0&id=42bfb9fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42bfb9fe"]])

export default __exports__